module.exports = __webpack_public_path__ + "static/media/Redeem.c851a696.png";